import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10087fb9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tasks-kanban-column-indicator__status"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tasks-kanban-column-indicator__status-dot tasks-kanban-column-indicator__dot" }, null, -1))
const _hoisted_3 = { class: "tasks-kanban-column-indicator__status-text" }
const _hoisted_4 = {
  key: 1,
  class: "tasks-kanban-column-indicator__priority"
}
const _hoisted_5 = { key: 4 }
const _hoisted_6 = {
  key: 5,
  class: "tasks-kanban-column-indicator__type"
}

import { PropType } from "vue";
import { GroupedTaskItemModel, TasksKanbanGroupingModel } from "../models";
import { FlagIcon } from "tir-style-system/icons/solid";
import { TirPmIconView } from "tir-components";
import { RectangleStackIcon } from "tir-style-system/icons/outline";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'TasksKanbanColumnIndicator',
  props: {
  /**Группировка */
  grouping: {
    type: Object as PropType<TasksKanbanGroupingModel | GroupedTaskItemModel>,
    required: true,
  },
},
  emits: ["mouseenter", "mouseleave"],
  setup(__props, { emit }) {




/**При наведении курсора */
const onMouseEnter = () => {
  emit("mouseenter");
};
/**При покидании курсора */
const onMouseLeave = () => {
  emit("mouseleave");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tasks-kanban-column-indicator",
    onMouseenter: onMouseEnter,
    onMouseleave: onMouseLeave
  }, [
    (__props.grouping.Status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "tasks-kanban-column-indicator__status-bg",
            style: _normalizeStyle({ backgroundColor: __props.grouping.Status.Color })
          }, null, 4),
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(__props.grouping.Status.Name), 1)
        ]))
      : (__props.grouping.Priority)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(FlagIcon), {
              class: "tasks-kanban-column-indicator__icon",
              style: _normalizeStyle({ color: __props.grouping.Priority.Color })
            }, null, 8, ["style"]),
            _createElementVNode("p", {
              class: "tasks-kanban-column-indicator__priority-text",
              style: _normalizeStyle({ color: __props.grouping.Priority.Color })
            }, _toDisplayString(__props.grouping.Priority.Name), 5)
          ]))
        : (__props.grouping.Performer)
          ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
              key: 2,
              size: 24,
              isRounded: "",
              colorCode: __props.grouping.Performer.NoPhotoColor,
              isBordered: false,
              imageLoadUrl: __props.grouping.Performer.ImageUrl
            }, {
              mainSlot: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.grouping.Performer.FirstName[0] + __props.grouping.Performer.LastName[0]), 1)
              ]),
              _: 1
            }, 8, ["colorCode", "imageLoadUrl"]))
          : (__props.grouping.Author)
            ? (_openBlock(), _createBlock(_unref(TirPmIconView), {
                key: 3,
                size: 24,
                isRounded: "",
                colorCode: __props.grouping.Author.NoPhotoColor,
                isBordered: false,
                imageLoadUrl: __props.grouping.Author.ImageUrl
              }, {
                mainSlot: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.grouping.Author.FirstName[0] + __props.grouping.Author.LastName[0]), 1)
                ]),
                _: 1
              }, 8, ["colorCode", "imageLoadUrl"]))
            : (__props.grouping.Tag)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", {
                    class: "tasks-kanban-column-indicator__tag",
                    style: _normalizeStyle({ borderColor: __props.grouping.Tag.Color })
                  }, [
                    _createElementVNode("div", {
                      class: "tasks-kanban-column-indicator__tag-bg",
                      style: _normalizeStyle({ backgroundColor: __props.grouping.Tag.Color })
                    }, null, 4),
                    _createElementVNode("span", {
                      class: "tasks-kanban-column-indicator__tag-text",
                      style: _normalizeStyle({ color: __props.grouping.Tag.Color })
                    }, _toDisplayString(__props.grouping.Tag.Name), 5)
                  ], 4)
                ]))
              : (__props.grouping.Type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_unref(RectangleStackIcon), { class: "tasks-kanban-column-indicator__icon" }),
                    _createTextVNode(" " + _toDisplayString(__props.grouping.Type.Name), 1)
                  ]))
                : _createCommentVNode("", true)
  ], 32))
}
}

})